module.exports = __webpack_public_path__ + "static/media/SAV_02.703c9b23.jpeg";